import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { UtilsService } from 'app/environment/services/utils.service';
import { BzgModalService } from 'bz-genome-angular';
import { FileExtensionAlertComponent } from '../modal-actions/security-authentication-file-extension.component';
import { CryptoDataService } from 'app/core/services/crypto.data.service';
import { NgForm } from '@angular/forms';
import { IOAuthOptionsFlowProperty } from 'app/security/core/typings/IAuthentication';

@Component({
  selector: 'biz-security-auth-detail',
  templateUrl: './security-auth-detail.component.html',
  styleUrls: ['./security-auth-detail.component.scss']
})
export class SecurityAuthDetailComponent implements OnInit {
  private _currentValue: string;
  private _currentValueClone: string;
  private _selectedOption: {
    key: string;
    value: string;
  } | IOAuthOptionsFlowProperty;

  @ViewChild('file', { static: false}) file;
  @ViewChild('numberInput', { static: false}) numberInput: any;

  @Input() selectedMetadata: { [key: string]: any };
  @Input() currentAllowedExtensions: string;
  @Input() isDisabled = false;
  @Input() currentFileName: string;
  @Input()
  public set selectedOption(value: {
    key: string;
    value: string;
  } | IOAuthOptionsFlowProperty) {
    this._currentValueClone = value ? _.clone(value.value) : null;
    this._selectedOption = value;
  }

  public get selectedOption(): {
    key: string;
    value: string;
  } | IOAuthOptionsFlowProperty {
    return this._selectedOption;
  }

  @Input()
  public get currentValue(): string {
    return this._currentValue;
  }
  public set currentValue(value: string) {
    this._currentValue = value;
  }


  public get fileNameProperty(): string {
    const something = (this.selectedOption as any).key ?
      (this.selectedMetadata[(this.selectedOption as any).key] as any).name :
      (this.selectedMetadata[(this.selectedOption as any).name] as any).name;
    return something;
  }


  @Input() isEditable = true;
  @Output() onUpdateData = new EventEmitter();

  constructor(
    public utilsService: UtilsService,
    private _modalService: BzgModalService,
    private _cryptoDataService: CryptoDataService, ) { }

  ngOnInit() {
  }

  async checkForPasswordOptionAdEncrypt() {
    if (!!(this.selectedOption as any).name) {
      const optionMetadata = this.selectedMetadata[(this._selectedOption as any).name];
      if (optionMetadata && optionMetadata.type === 'password') {
        this.currentValue = await this._cryptoDataService.encryptStringPromise(this.currentValue);
        this._currentValueClone = _.cloneDeep(this._currentValue);
      }
    } else {
      if ((this.selectedMetadata[(this._selectedOption as any).key] as any).type === 'password') {
        this.currentValue = await this._cryptoDataService.encryptStringPromise(this.currentValue);
        this._currentValueClone = _.cloneDeep(this._currentValue);
      }
    }
  }

  updateData(option: { [key: string]: string } | IOAuthOptionsFlowProperty,
    currentValue: string,
    isOauth = false,
    fileName?: string,
    currentFileName?: string) {

    this._currentValueClone = _.cloneDeep(this._currentValue);

    this.onUpdateData.emit({
      option,
      currentValue,
      isOauth,
      fileName,
      currentFileName
    });
  }

  get hasChanges(): boolean {
    return !_.isEqual(this._currentValue, this._currentValueClone);
  }

  public setCurrentBooleanValue(value: boolean) {
    this.currentValue = value ? 'True' : 'False';
  }

  public uploadFile() {
    this.file.nativeElement.click();
  }

  public readFile(input) {
    const file: File = input.files[0];

    if (file) {
      const splittedName: Array<string> = file.name.split('.');
      const extension: string = splittedName[splittedName.length - 1];

      if (this.currentAllowedExtensions.includes(extension)) {
        const fileReader: FileReader = new FileReader();

        fileReader.onloadend = e => {
          const fileContentParts = (fileReader.result as string).split(',');
          this.currentValue =
            fileContentParts.length === 1
              ? fileContentParts[0]
              : fileContentParts[1];
          this.currentFileName = file.name;
        };
        fileReader.readAsDataURL(file);
      } else {
        this._modalService.open(FileExtensionAlertComponent, {
          closeOnBackdropClick: false,
          closeOnRouterNavigation: true,
        });
      }
    }
  }

  public isFormValid() {
    return (
      !this.numberInput ||
      (Number(this.numberInput.value) >= this.numberInput.min &&
        Number(this.numberInput.value) <= this.numberInput.max)
    );
  };
}
